// hooks/useRequestProductListVariants.js
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import componentLoader from 'Util/componentLoader';

export const ProductsVariantsDispatcher = componentLoader(() => import(
    'Store/ProductsVariants/ProductsVariants.dispatcher'
), 2);

/** @namespace Bodypwa/Hooks/UseRequestProductListVariants/useRequestProductListVariants */
export const useRequestProductListVariants = () => {
    const dispatch = useDispatch();

    const categoryId = useSelector((state) => state.ProductListReducer.id);

    return useCallback((sku, page) => {
        if (!sku) {
            return;
        }

        const options = {
            args: {
                filter: {
                    productsSkuArray: [sku]
                }
            },
            id: categoryId,
            page,
            isPdp: false
        };

        ProductsVariantsDispatcher.then(({ default: dispatcher }) => {
            dispatcher.handleData(dispatch, options);
        });
    }, [dispatch, categoryId]);
};
